import { productPage } from 'utils/pageTemplates/productPage';

const { getStaticProps, getStaticPaths, ProductPageComponent } = productPage({
  category: 'skincare',
});

export { getStaticPaths, getStaticProps };
export default ProductPageComponent;
